import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Mitarbeiter } from '@/domain/navigation/benachrichtigungen/types/Benachrichtungen';
import { faShareNodes } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { HTMLAttributes, ReactNode } from 'react';

export function DetailWrapper({
  mitarbeiter,
  content,
  footer,
  rightSide,
  ...others
}: {
  mitarbeiter: Mitarbeiter;
  content?: ReactNode;
  footer?: ReactNode;
  rightSide?: ReactNode;
} & Omit<HTMLAttributes<HTMLDivElement>, 'content'>) {
  return (
    <div className={`flex gap-3 md:w-64 group`} {...others}>
      <Avatar className="size-8 md:size-10">
        {mitarbeiter.istExtern ? (
          <AvatarFallback>
            <FontAwesomeIcon
              className="text-primary-red-400"
              icon={faShareNodes}
            />
          </AvatarFallback>
        ) : (
          <>
            <AvatarImage src={mitarbeiter.bildUrl} />
            <AvatarFallback>{`${mitarbeiter.vorname
              .substring(0, 1)
              .toUpperCase()}${mitarbeiter.nachname
              .substring(0, 1)
              .toUpperCase()}`}</AvatarFallback>
          </>
        )}
      </Avatar>
      <div className="flex justify-between items-start grow">
        <div className="flex gap-2 flex-col w-full">
          <p className="text-sm">{`${mitarbeiter.vorname} ${mitarbeiter.nachname}`}</p>
          {content && <>{content}</>}
          {footer && <p className="text-xs text-neutrals-700">{footer}</p>}
        </div>
        {rightSide && (
          <div className="hidden group-hover:inline-flex">{rightSide}</div>
        )}
      </div>
    </div>
  );
}
